"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTheme = setTheme;
exports.getComputedStyles = getComputedStyles;
exports.reverseBackgroundColor = reverseBackgroundColor;
exports.reverseFontColor = reverseFontColor;
exports.makeReversedColor = makeReversedColor;
exports.applyDarkModeToNode = applyDarkModeToNode;
exports.applyDarkModeToStyle = applyDarkModeToStyle;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _chromaJs = _interopRequireDefault(require("chroma-js"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _zipWith = _interopRequireDefault(require("lodash/zipWith"));

var _constants = require("../utils/constants");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = (0, _wrapNativeSuper2["default"])(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } (0, _inherits2["default"])(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if ((0, _typeof2["default"])(args[args.length - 1]) !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function setTheme(theme) {
  var element = document.documentElement;

  if ((0, _isNil["default"])(element)) {
    return;
  }

  var attributes = element.attributes;

  if ((0, _isNil["default"])(attributes)) {
    return;
  }

  if (theme === 'dark') {
    element.setAttribute('data-theme', 'dark');
    element.classList.add('dark');
  } else {
    element.setAttribute('data-theme', 'light');
    element.classList.remove('dark');
  }
}

function getComputedStyles() {
  var styles = window.getComputedStyle(document.documentElement);
  return {
    get: function get(key, defaultVal) {
      var match = /*#__PURE__*/_wrapRegExp(/var\(([\0-\(\*-\uFFFF]+)\)/, {
        key: 1
      }).exec(key);

      if (match && match.groups) {
        return styles.getPropertyValue(match.groups.key).trim();
      } else {
        return defaultVal;
      }
    }
  };
}
/**
 * Reference: http://alienryderflex.com/hsp.html
 *
 * HSP value is to tell whether the color is dark or bright
 */


function colorHSP(color) {
  var _chroma$rgb = (0, _chromaJs["default"])(color).rgb(),
      _chroma$rgb2 = (0, _slicedToArray2["default"])(_chroma$rgb, 3),
      r = _chroma$rgb2[0],
      g = _chroma$rgb2[1],
      b = _chroma$rgb2[2];

  return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
}

function reverseBackgroundColor(color) {
  var baseColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000';

  if (!_chromaJs["default"].valid(color)) {
    return color;
  }

  var colorChroma = (0, _chromaJs["default"])(color);
  var hsp = colorHSP(color);
  var delta = hsp > 200 ? -hsp : 0;
  return (0, _chromaJs["default"])([].concat((0, _toConsumableArray2["default"])((0, _zipWith["default"])(colorChroma.rgb(), (0, _chromaJs["default"])(baseColor).rgb(), function (a, b) {
    return Math.max(a + delta, b);
  })), [colorChroma.alpha()]));
}

function reverseFontColor(color) {
  var baseColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#fff';

  if (!_chromaJs["default"].valid(color)) {
    return color;
  }

  var colorChroma = (0, _chromaJs["default"])(color);
  var hsp = colorHSP(color);
  var delta = hsp < 130 ? 0xff - hsp : 0;
  return (0, _chromaJs["default"])([].concat((0, _toConsumableArray2["default"])((0, _zipWith["default"])(colorChroma.rgb(), (0, _chromaJs["default"])(baseColor).rgb(), function (a, b) {
    return Math.min(a + delta, b);
  })), [colorChroma.alpha()]));
}

function makeReversedColor(darkMode) {
  var _ref = darkMode || _constants.DEFAULT_DARK_MODE,
      enable = _ref.enable,
      baseColor = _ref.color,
      baseBackgroundColor = _ref.backgroundColor; // INFO: Only reverse the color for font and background in dark mode


  return {
    color: function color(input) {
      return enable ? reverseFontColor(input, baseColor) : input;
    },
    backgroundColor: function backgroundColor(input) {
      return enable ? reverseBackgroundColor(input, baseBackgroundColor) : input;
    }
  };
}

function applyDarkModeToNode(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$baseColorSch = options.baseColorScheme,
      baseColor = _options$baseColorSch.color,
      baseBackgroundColor = _options$baseColorSch.backgroundColor;

  function apply(prop, color, baseColor, handler) {
    if (color && _chromaJs["default"].valid(color) && (0, _chromaJs["default"])(color).get('rgba.a') !== 0) {
      target.style.setProperty(prop, handler(color, baseColor), 'important');
    }
  }

  var fontColor = target.style.getPropertyValue('color');

  if (!fontColor) {
    fontColor = target.getAttribute('color');
  }

  apply('color', fontColor, baseColor, reverseFontColor);
  var backgroundColor = target.style.getPropertyValue('background-color');

  if (!backgroundColor) {
    backgroundColor = target.getAttribute('bgColor');
  }

  apply('background-color', backgroundColor, baseBackgroundColor, reverseBackgroundColor);
}

function applyDarkModeToStyle(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$baseColorSch2 = options.baseColorScheme,
      baseColor = _options$baseColorSch2.color,
      baseBackgroundColor = _options$baseColorSch2.backgroundColor; // $FlowFixMe

  if (!target.sheet && target.sheet.cssRules.length === 0) {
    return;
  }

  function apply(rule, prop, baseColor, handler) {
    var color = rule.style.getPropertyValue(prop);

    if (color && _chromaJs["default"].valid(color) && (0, _chromaJs["default"])(color).get('rgba.a') !== 0) {
      rule.style.setProperty(prop, handler(color, baseColor), 'important');
    }
  } // $FlowFixMe


  var rules = Array.from(target.sheet.cssRules).flatMap(function (rule) {
    // $FlowFixMe
    if ('cssRules' in rule && rule.cssRules.length > 0) {
      // $FlowFixMe
      return [rule].concat((0, _toConsumableArray2["default"])(Array.from(rule.cssRules)));
    } else {
      return [rule];
    }
  }).filter(function (rule) {
    return rule.type === CSSRule.STYLE_RULE;
  });

  var _iterator = _createForOfIteratorHelper(rules),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      apply(rule, 'color', baseColor, reverseFontColor);
      apply(rule, 'background-color', baseBackgroundColor, reverseBackgroundColor);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
//# sourceMappingURL=utils.js.map